export default __webpack_public_path__ + "static/media/twitter.4ac98dd5.svg";